module.exports = __webpack_public_path__ + "static/media/custom.c6ae276d.gif";